module.exports = __webpack_public_path__ + "static/img/logo_JX.cf7beb6b.png";